import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=befae9c2"
import script from "./IconSelector.vue?vue&type=script&lang=ts"
export * from "./IconSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports